import React from 'react'
import mousetrap from 'mousetrap'

interface IProps {
  keys: string | string[]
  target?: React.RefObject<any>
  preventDefault?: boolean
  stopPropagation?: boolean
  onMatch: (e: ExtendedKeyboardEvent, keys: string) => void
}

class Mousetrap extends React.PureComponent<IProps> {
  static defaultProps = {
    preventDefault: true,
    stopPropagation: true,
  }

  instance!: MousetrapInstance // `!` is fine because we will assign it in componentDidMount, which is okay

  componentDidMount() {
    const {
      target: propTarget,
      keys,
      preventDefault,
      stopPropagation,
      onMatch,
    } = this.props

    const target = propTarget?.current ?? document
    this.instance = mousetrap(target)
    this.instance.bind(
      keys,
      (e, keys) => {
        preventDefault && e.preventDefault()
        stopPropagation && e.stopImmediatePropagation()
        onMatch(e, keys)
      },
      'keydown'
    )
  }

  componentWillUnmount() {
    this.instance.unbind(this.props.keys, 'keydown')
  }

  render() {
    return <></>
  }
}

export default Mousetrap
